import moment from 'moment';
import { useSelector } from 'react-redux';
import { SHORT_DATE_FORMAT } from 'common/constants/constants';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import Icon from 'components/base/Icon';
import { Tooltip } from '@material-ui/core';
import { PERIODS } from 'components/PeriodPicker/periods/constants';
import {
  dateRangeSelector,
  selectedPeriodKeySelector
} from 'state/selectors/ui-state';

const TopReviewer = ({ reviews, isBurnout, isWipOverload, name }) => {
  const showTopReviewerText = !isBurnout && !isWipOverload;
  const selectedPeriodKey = useSelector(selectedPeriodKeySelector);
  const dateRange = useSelector(dateRangeSelector);
  const { from, to } = dateRange;
  const customDatesFormattedText = `for ${moment(from).format(
    SHORT_DATE_FORMAT
  )} - ${moment(to).format(SHORT_DATE_FORMAT)}`;

  const selectedPeriodText =
    selectedPeriodKey === PERIODS.CUSTOM.periodKey
      ? customDatesFormattedText
      : PERIODS[selectedPeriodKey]?.topReviewerText;

  return (
    <Flex>
      {showTopReviewerText && (
        <Flex items='center' justify='center'>
          <Text
            size='large'
            weight={400}
            data-testid='top-reviewer-text'
            className='status-text'
          >
            {reviews} reviews
          </Text>
        </Flex>
      )}
      <Tooltip
        title={
          <Flex padding='tooltip' direction='column'>
            <Text
              color='shuttleGray'
              size='medium'
              data-testid='top-reviewer-tooltip-text'
            >
              {name} is the top reviewer with {reviews} reviews{' '}
              {selectedPeriodText}.
            </Text>
          </Flex>
        }
      >
        <Icon
          name='TopReviewer'
          color='terracotta'
          size='large'
          data-testid='top-reviewer-icon'
        />
      </Tooltip>
    </Flex>
  );
};

export default TopReviewer;
